import React, { ReactElement, useState } from 'react';
import HeaderTitle from '../../modularcomponents/header/headertitle';
import HeaderProperty from '../../modularcomponents/header/headerproperty';
import HeaderPropertyName from '../../modularcomponents/header/headerpropertyname';
import HeaderPropertyValue from '../../modularcomponents/header/headerpropertyvalue';
import HeaderContainer from '../../modularcomponents/header/headercontainer';
import HeaderItems from '../../modularcomponents/header/headeritems';
import HeaderItem from '../../modularcomponents/header/headeritem';
import { DdReportBlock } from '../../../types/types';
import HeaderButtons from '../../modularcomponents/header/headerbuttons';
import { DdReportBlocksService } from '../../../services/import';
import VersionsSubHeader from '../VersionsSubHeader';
import HeaderSummary from '../../modularcomponents/header/headersummary';

function DdReportBlockHeader(props: {ddReportBlock: DdReportBlock}): ReactElement {
  const active = `${props.ddReportBlock.versionManagement?.active === undefined ? '' : props.ddReportBlock.versionManagement.active}`;
  const [expand, setExpand] = useState(false);

  const toggleExpand = () => {
    setExpand(val => !val);
  };

  return (
    <HeaderContainer expanded={expand} setExpanded={setExpand}>
      <HeaderSummary toggleExpand={toggleExpand}>
        <HeaderTitle toggleExpand={toggleExpand} type='' name={props.ddReportBlock.fullRef} />
        <HeaderButtons id={props.ddReportBlock._id} service={new DdReportBlocksService()} actionList={[]} />
      </HeaderSummary>
      <HeaderItems>
        <HeaderItem>
          <HeaderProperty>
            <HeaderPropertyName name='Full Ref' />
            <HeaderPropertyValue>
              {props.ddReportBlock.fullRef}
            </HeaderPropertyValue>
          </HeaderProperty>

          <HeaderProperty>
            <HeaderPropertyName name='Simple Id' />
            <HeaderPropertyValue>
              {props.ddReportBlock.versionManagement.simpleId}
            </HeaderPropertyValue>
          </HeaderProperty>

          <HeaderProperty>
            <HeaderPropertyName name='Version' />
            <HeaderPropertyValue>
              {props.ddReportBlock.versionManagement.version.toString()}
            </HeaderPropertyValue>
          </HeaderProperty>

          <HeaderProperty>
            <HeaderPropertyName name='Active' />
            <HeaderPropertyValue>
              {active.charAt(0).toUpperCase() + active.slice(1)}
            </HeaderPropertyValue>
          </HeaderProperty>
        </HeaderItem>
      </HeaderItems>
      <VersionsSubHeader<DdReportBlock> id={props.ddReportBlock._id} service={new DdReportBlocksService()} />
    </HeaderContainer>
  );
}

export default DdReportBlockHeader;
